const mutationTypes = {
  SET_SURVEYS: 'SET_SURVEYS',
  REPLACE_SURVEY: 'REPLACE_SURVEY',
  SET_SELECTED_SURVEY: 'SET_SELECTED_SURVEY',
}

const actionTypes = {
  FETCH_SURVEYS: 'FETCH_SURVEYS',
  FETCH_SURVEY: 'FETCH_SURVEY',
  CREATE_SURVEY: 'CREATE_SURVEY',
  COPY_SURVEY: 'COPY_SURVEY',
  EDIT_SURVEY: 'EDIT_SURVEY',
  DELETE_SURVEY: 'DELETE_SURVEY',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/SurveysTypes.js